<template>
  <section class="section" ref="home">
    <div class="title is-2">{{ $t("al tempo's online orders") }}</div>
    <div class="subtitle is-5">
      {{ $t("delicious bread, delicious pizza, place your order") }}
    </div>
    <div class="grid is-col-min-7">
      <div class="cell" @click="make_order">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/512/4866/4866645.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("make an order") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cell" @click="find_order">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/512/4420/4420302.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("find your order") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <order ref="order" @home="home" />
  <!-- <find ref="find" @home="home" /> -->
</template>

<script>
import { get } from "@/utils";
import Order from "./Order.vue";
// import Find from "./Find.vue";

export default {
  name: "BakeryOnlineOrderIndex",
  components: { Order /* Find */ },
  data() {
    return {
      order_link: {},
    };
  },
  methods: {
    make_order() {
      let v = this;
      v.$refs.order.show_component();
      window.jQuery(v.$refs.home).hide();
    },
    // find_order() {
    //   let v = this;
    //   v.$refs.find.show_component();
    //   window.jQuery(v.$refs.home).hide();
    // },
    home() {
      let v = this;
      v.$refs.order.hide();
      // v.$refs.find.hide();
      window.jQuery(v.$refs.home).show();
    },
  },
  mounted() {},
  // Tus opciones y lógica aquí
};
</script>

<style scoped>
/* Tus estilos aquí */
</style>
